export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14335.eafc72b9.jpg";